export enum FilterDropdownInputDataAttributes {
  /**
   * Present when the input receives virtual focus via keyboard navigation.
   */
  focusVisible = 'data-focus-visible',
}
